<script setup>
// Curva de 30 dias do agente. Desenhada à mão em SVG porque é um sparkline de 30 pontos:
// trazer uma biblioteca de gráfico para isso custa mais em bundle do que o componente inteiro.
//
// A série vem do payload da lista (mensagens/dia nas inboxes do agente). Zero é zero de
// verdade — "nenhuma mensagem" —, não "sem dado": agente sem inbox não desenha linha nenhuma,
// e a tela diz isso com o alerta em vez de fingir uma reta.
import { computed } from 'vue';

const props = defineProps({
  series: { type: Array, default: () => [] },
});

const L = 30;
const A = 32; // altura do desenho: card compacto pede curva mais baixa

const pontos = computed(() => {
  const s = props.series.length ? props.series : Array(L).fill(0);
  const max = Math.max(...s, 1);
  return s
    .map((v, i) => `${(i / (s.length - 1)) * 100},${A - (v / max) * (A - 2) - 1}`)
    .join(' ');
});

const temMovimento = computed(() => props.series.some(v => v > 0));
</script>

<template>
  <svg
    :viewBox="`0 0 100 ${A}`"
    preserveAspectRatio="none"
    class="w-full h-8"
    aria-hidden="true"
  >
    <polyline
      :points="pontos"
      fill="none"
      :class="temMovimento ? 'stroke-n-brand' : 'stroke-n-slate-6'"
      stroke-width="1.2"
      vector-effect="non-scaling-stroke"
      stroke-linejoin="round"
      stroke-linecap="round"
    />
  </svg>
</template>
